var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCardIcon = function SvgMasterCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    fill: "none",
    viewBox: "0 0 50 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "#F5F7FA",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A00",
    d: "M28.777 7.846H21.2v13.57h7.577z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M21.705 14.632c0-2.757 1.3-5.204 3.295-6.786A8.63 8.63 0 0 0 19.659 6C14.873 6 11 9.86 11 14.632c0 4.771 3.873 8.632 8.659 8.632A8.63 8.63 0 0 0 25 21.417a8.6 8.6 0 0 1-3.295-6.785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M39 14.632c0 4.771-3.873 8.632-8.659 8.632A8.63 8.63 0 0 1 25 21.417a8.57 8.57 0 0 0 3.295-6.785c0-2.757-1.3-5.204-3.295-6.786A8.6 8.6 0 0 1 30.338 6C35.128 6 39 9.886 39 14.632"
  })));
};
export default SvgMasterCardIcon;